// extracted by mini-css-extract-plugin
export default {"header":"GlobalLayout_header__F3wLx","left-side-text":"GlobalLayout_left-side-text__rQ-RG","title":"GlobalLayout_title__-oEgI"};